var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 2764,
    viewBox: "0 0 629 2764",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609 691.5C738.6 518.7 786.667 358.5 794.5 300L703 2464C676.167 2343.67 600.7 2061 513.5 1893C426.3 1725 334.833 1699.33 300 1707.5C387.833 1653.5 583.7 1502.7 664.5 1331.5C765.5 1117.5 447 907.5 609 691.5Z",
    fill: "#1E90FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_494",
    x: 0,
    y: 0,
    width: 1094.5,
    height: 2764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1_494"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRightBlue);
export default __webpack_public_path__ + "static/media/bg-right-blue.286ca2ae449d891dd443a49a5ccc9827.svg";
export { ForwardRef as ReactComponent };